import React, { useState } from "react";
import { Plus, Minus } from "react-feather";

const FAQ = ({ onContactClick }) => {
	const [activeIndex, setActiveIndex] = useState(null);

	const faqs = [
		{
			question: "What is period poverty?",
			answer: "Period poverty is when girls and women lack access to safe, affordable menstrual products and education. It impacts health, dignity, and causes many girls to miss school.",
		},
		{
			question: "How does Swift Haven address period poverty?",
			answer: "We provide pads through our community-powered dispenser network and create safe spaces called Haven Circles, where girls access products, knowledge, and support.",
		},
		{
			question: "Where does Swift Haven operate?",
			answer: "We started in *Rwanda* and are expanding to underserved school communities across Africa.",
		},
		{
			question: "How can I support Swift Haven?",
			answer: `* Donate to fund pad access.
					* Partner with us as a school, business, or NGO.
					* Volunteer your skills.
					* Share our mission.`,
		},
		{
			question: "Is the program sustainable?",
			answer: "Yes. We partner locally, build community ownership, and are developing a social enterprise arm to help fund long-term access.",
		},
		{
			question: "How do girls access the sanitary products?",
			answer: "Through our pad dispensers placed in schools and communities, stocked regularly and free for girls.",
		},
	];

	const toggleFAQ = (index) => {
		setActiveIndex(activeIndex === index ? null : index);
	};

	return (
		<section className="bg-gradient-to-b from-swift-pink/10 to-white py-16 lg:py-20 px-6">
			<div className="container">
				{/* Title Section */}
				<div className="max-w-4xl mb-16">
					<h2 className="text-2xl lg:text-3xl xl:text-4xl font-light text-gray-600 leading-tight mb-6 font-generalSans">
						Empowering{" "}
						<span className="text-swift-pink">Girls Through</span>{" "}
						Knowledge
					</h2>
				</div>

				{/* FAQ Blocks Container - Full Width */}
				<div className="w-full">
					<div className="bg-swift-pink rounded-lg p-8 space-y-0">
						{faqs.map((faq, index) => (
							<div key={index}>
								{/* Question Block */}
								<button
									className="w-full text-left py-6 flex items-center justify-between text-white hover:scale-[1.01] transition-colors duration-200 rounded-lg px-4"
									onClick={() => toggleFAQ(index)}
									aria-expanded={activeIndex === index}
								>
									<span className="text-lg font-light font-generalSans">
										{faq.question}
									</span>
									{activeIndex === index ? (
										<Minus className="w-6 h-6 text-white" />
									) : (
										<Plus className="w-6 h-6 text-white" />
									)}
								</button>

								{/* Answer Block */}
								{activeIndex === index && faq.answer && (
									<div className="px-4 pb-6">
										<p className="text-white/90 text-sm leading-relaxed pl-2 font-generalSans font-light">
											{faq.answer}
										</p>
									</div>
								)}

								{/* Divider Line */}
								{index < faqs.length - 1 && (
									<hr className="border-gray-400/30" />
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export default FAQ;
